import { render } from "./CubeScriptView.vue?vue&type=template&id=538a97db&scoped=true&ts=true"
import script from "./CubeScriptView.vue?vue&type=script&lang=ts"
export * from "./CubeScriptView.vue?vue&type=script&lang=ts"

import "./CubeScriptView.vue?vue&type=style&index=0&id=538a97db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538a97db"]])

export default __exports__